/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type AgencyClubsControllerListAgencyClubsV1SortBy = typeof AgencyClubsControllerListAgencyClubsV1SortBy[keyof typeof AgencyClubsControllerListAgencyClubsV1SortBy];


export const AgencyClubsControllerListAgencyClubsV1SortBy = {
  recent: 'recent',
  name: 'name',
  relationship: 'relationship',
  country: 'country',
  budget: 'budget',
} as const;
